export default {
    apiURL: (window.variables && window.variables.API) || process.env.VUE_APP_API_URL

}